import { useEffect, useState } from 'react'

import Breadcrumbs from '../atomic/Breadcrumbs'
import GenericPageTab from '../atomic/GenericPageTab'
import PlaceholderReact from 'components/atomic/PlaceholderReact'
import TabProgettoSpecialeCard from '../card/TabProgettoSpecialeCard'
import { connect } from 'react-redux'

const ProgettiSpeciali = ({ page, toolbar }) => {
  const [pagina, setPagina] = useState(page)

  const [sectionClasses, setSectionClasses] = useState([])
  const [mainSectionClasses, setMainSectionClasses] = useState(
    'progetti-speciali__main-section section u-before-section'
  )

  const initSectionClasses = () => {
    let classes = []

    pagina.tabs.forEach((t, index) => {
      let baseClass = 'progetti-speciali__section '

      if (typeof window !== 'undefined' && window.innerWidth > 767) {
        baseClass += 'section u-before-section '
        if (!index || index % 2 === 0) baseClass += 'u-bg-beige'
        else baseClass += 'u-bg-white'
      }

      classes[index] = baseClass
    })

    setSectionClasses(classes)

    if (typeof window !== 'undefined' && window.innerWidth < 768) {
      setMainSectionClasses('progetti-speciali__main-section section')
    }
  }

  useEffect(() => {
    initSectionClasses()
  }, [])

  let customCta = null
  if (pagina.link_esterno && pagina.cta) {
    customCta = (
      <a
        className="button button--primary button--inverted"
        href={pagina.link_esterno}
        target="_blank"
      >
        {pagina.cta}
      </a>
    )
  }

  const background = pagina.main_image
    ? { backgroundImage: `url(${pagina.main_image})` }
    : { backgroundColor: `black` }

  return (
    <>
      <main className="cms-page cms-page--progetti-speciali">
        <div className="w-container-fluid u-before-section u-background-image" style={background}>
          <div className="w-container">
            <Breadcrumbs breadcrumbs={pagina.breadcrumbs} />
          </div>

          <section className="progetti-speciali__header">
            <div className="w-container">
              <h1
                className="progetti-speciali__title"
                style={{ color: page?.font_color ? `${page.font_color}` : undefined }}
              >
                {pagina.titolo}
              </h1>
              <p
                className="progetti-speciali__subtitle"
                style={{ color: page?.font_color ? `${page.font_color}` : undefined }}
              >
                {pagina.descrizione}
              </p>
            </div>
          </section>
        </div>
        <section className={mainSectionClasses}>
          <div className="w-container">
            <div className="progetti-speciali__abstract">
              <PlaceholderReact
                pkey={`progetti-speciali-${pagina.id}-intro`}
                contentTypeId={pagina.model}
                objectId={pagina.id}
              />
            </div>
            <section className="progetti-speciali__cards">
              {pagina.tabs.map((tab) => (
                <TabProgettoSpecialeCard tab={tab} key={tab.id} />
              ))}
            </section>
            <div className="progetti-speciali__subintro desktop">
              <PlaceholderReact
                pkey={`progetti-speciali-${pagina.id}-subintro`}
                contentTypeId={pagina.model}
                objectId={pagina.id}
              />
            </div>
          </div>
        </section>
        {pagina.tabs.map((tab, index) => (
          <section className={sectionClasses[index]} key={index}>
            <header className="progetti-speciali__section__header">
              <h2 id={tab.slug} className="progetti-speciali__section__title heading2-secondary">
                {tab.titolo}
              </h2>
            </header>
            <GenericPageTab tab={tab} progettiSpeciali>
              <div className="w-container">
                <PlaceholderReact
                  pkey={`${pagina.id}-${tab.slug}-content`}
                  contentTypeId={pagina.model}
                  objectId={pagina.id}
                />
              </div>
            </GenericPageTab>
          </section>
        ))}
        <div className="progetti-speciali__subintro mobile">
          <PlaceholderReact
            pkey={`progetti-speciali-${pagina.id}-subintro`}
            contentTypeId={pagina.model}
            objectId={pagina.id}
          />
        </div>
        <div className="progetti-speciali__contenuto-indicizzabile">
          {pagina.contenuto_indicizzabile}
        </div>
      </main>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    toolbar: state.toolbar,
  }
}

export default connect(mapStateToProps, null)(ProgettiSpeciali)
